export default "__VITE_ASSET__B58FOeDK__"